import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import Creatable from "react-select/creatable";
import { useTranslation } from "react-i18next";
import WorldFlag from 'react-world-flags';
import Select, { components } from 'react-select';
import omit from "lodash/omit";
import convert from "convert";
import {
  Modal,
  Button,
  Row,
  Col,
  Container,
  Card,
  Badge,
  Form,
  Spinner,
} from "react-bootstrap";
import { withAsyncPaginate } from "react-select-async-paginate";

import request from "services/request";
import SelectInput from "components/selectInput";
import { useLoading } from "contexts/LoadingContextManagement";
import { useUserData } from "contexts/AuthContextManagement";
import {
  DEFAULT_ERROR_MESSAGE,
  CARBON_MEAL_CATEGORIES,
  CO2_UNITS,
  COOKING_OPTIONS,
  MEAL_CATEGORIES,
  SERVICE_TYPES,
  COUNTRY_CODE_OPTIONS,
  REFERENCE_PORTION_WEIGHTS,
} from "common/constants";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { cloneDeep, searchIngredients, calculateDynamicThresholds } from "common/utils.ts";
import translations from '../../../data/ingredients_translations.json'
import FrTranslation from '../../../data/eng-to-fr-ingredients.json'
import SelectAsyncPaginate from "components/selectAsyncPaginate/index.tsx";
import AddIngredientModal from "./modal.js"

import UploadedIcon from "assets/images/uploaded_meal.png";
import Addicon from "assets/images/icon/add_purple.svg";
import TelechargerIcon from "assets/images/telecharger.png";

import JPEG_ICON from "assets/images/icon/jpeg.svg";
import CLOSE_ICON from "assets/images/icon/DELETE.svg";
import EYE_ICON from "assets/images/icon/eye.svg";
import Calque from "assets/images/Calque2.png"
import ImportIcon from "assets/images/icon/import-icon.svg";
import ExistingRecipeIcon from "assets/images/icon/existing-recipe-icon.svg";
import Mic from "assets/images/speaker.png"
import Calque_2 from "assets/images/Calque_2.png"
import INFO_ICON from "assets/images/info.png"
import NO_IMAGE_ICON from "assets/images/default-image-icon.png"

import { roundToTwo } from "common/utils";
import { useOnDropAccepted } from 'common/utils.ts';
import { getConvertibleUnitOptions, mealsKeys, requiredMealsKeys } from "../../settings/utils";
import { toast } from "react-toastify";
import dummyIngredients from '../../../data/carbon_ingredient.json'
import carbon_footprint_recipes from "../../../data/carbon_footprint_recipes.json"
import typeTranslationEnFrMap from '../../../data/type_en_fr_translation.json'
import typeTranslationFrENMap from '../../../data/type_fr_en_translation.json'

import ProgressItem from "./progressItem";
import ImportModule from "../../settings/common/ImportIngredients";

import './index.scss'
import storage from "services/storage";
import SWITCH from "assets/images/switch.png";
import { use } from "i18next";
const CreatableAsyncPaginate = withAsyncPaginate(Creatable);

const INGREDIENT_INITIAL = {
  ingredient_unit: "kg",
  ingredient_quantity: 1,
  ingredient_cost: 0,
  converted_unit: "g",
  ingredient_id: {
    id: null,
    name: null,
    unit: null,
  },
  converted_quantity: 1000,
  name: "",
  country:null
};

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "auto",
  height: "100%",
};

const customStyles = {
  // This styles the dropdown itself
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    backgroundColor: "white",
    overflowX: "hidden",
  }),
  
  // This styles the portal (where the menu is rendered)
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,  // You can adjust this if needed to ensure it's above other elements
    backgroundColor: "white",
    overflowX: "hidden",
  }),
};



function CustomModal({ onHide, show, state, onRowAdded, ...props }) {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { setLoading, setError } = useLoading();
  const [ingredientModal, setIngredientModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [isUploaded, setIsUploaded] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [ingredients, setIngredients] = useState([])
  const [selectedIngredients, setSelectedIngredients] = useState([])
  const [showInfo, setShowInfo] = useState(false);
  const [showLocalInfo, setShowLocalInfo] = useState(false);
  const [importDocument, setImportDocument] = useState(false)
  const [lowerIngredients, setLowerIngredients] = useState([])
  const [alternativeIngredients, setAlternativeIngredients] = useState([])
  const [isAlternativeLoading, setIsAlternativeLoading] = useState(false)
  const [isAILoading, setIsAILoading] = useState(false)
  const [fileImportLoading, setFileImportLoading] = useState(false)
  const [isLoadAlternative, setIsLoadAlternative] = useState(true)
  const [isSwitched, setIsSwitched] = useState(false)
  const [nextLoadAlternative,setNextLoadAlternative] = useState(false)
  const [fd, setFd] = useState({
    allergens: [],
    ingredients: [],
    meals: [],
    service_type: "plated",
  });
  const [currentColor, setCurrentColor] = useState(getColorBasedOnCarbonEmission(getSum()?.toFixed(2)).color)
  const is_demo = JSON.parse(storage.getItem("is_demo"))
  const currentBrand = storage.getItem("brand");
  let sumOfCarbonValue = fd.ingredients?.reduce((previousValue, currentValue) => previousValue + (currentValue?.carbon_emission || 0), 0);
  const prevFdQuantity = useRef();
  const { selectedRestaurantId, selectedRestaurant, hasRetaurants, isRestaurantLoaded, setSampleRestaurantModal } = useUserData();
  const imageUrl = `${process.env.PUBLIC_URL}/images/brands/${currentBrand}-${getColorBasedOnCarbonEmission(getSum()?.toFixed(2)).offset}.png`;
  const [offset, setOffset] = useState(null)
  const onDropAccepted = useOnDropAccepted(setFiles, setError, t);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [selectedCookingState, setSelectedCookingState] = useState(null);
  const [mealNameSelectKey, setMealNameSelectKey] = useState(0);
  const [allAlternativesExhausted, setAllAlternativesExhausted] = useState(false);
  const failedAlternativesRef = useRef(new Set());
  let prevTotalWeight = useRef(null)
  const currentMonth = new Date().toLocaleString('en-US', { month: 'long' });
  const [cookingStates, setCookingStates] = useState([])
  const translatedCO2Units = useMemo(() => CO2_UNITS.map(u => ({ ...u, label: t(u.label) })), [t])
  const translatedCountryOptions = useMemo(() => {
    const displayNames = new Intl.DisplayNames([currentLanguage], { type: 'region' });
    return COUNTRY_CODE_OPTIONS.map(country => ({
      ...country,
      label: displayNames.of(country.id) || country.label
    }));
  }, [currentLanguage])

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: "image/jpg, image/jpeg, image/png, application/pdf",
    maxFiles: 1,
    onDropAccepted
  });

  useEffect(() => {
    setCurrentColor(getColorBasedOnCarbonEmission(getSum()?.toFixed(2)).color)
    switch(getColorBasedOnCarbonEmission(getSum()?.toFixed(2)).offset) {
      case 0:
        setOffset(10);
        break;
      case 25:
        setOffset(30);
        break;
      case 50:
        setOffset(50);
        break;
      case 75:
        setOffset(70);
        break;
      case 100:
        setOffset(90);
        break;
    }
  }, [imageUrl])

  // Toggle row function
  const handleRowClick = async(index) => {
    const willOpen = selectedRowIndex !== index;
    setSelectedRowIndex(willOpen ? index : null);

    if (!willOpen) return;

    const ingredient = fd?.ingredients?.[index];
    setSelectedCookingState(ingredient?.type ?? 'None');

    const ingredientName = ingredient?.ingredient_id?.name;
    if (!ingredientName) {
      setCookingStates(['None']);
      return;
    }

    try {
      const response = await request.get(
        `carbon-footprints/ingredients/get-ingredient-type`,
        { ingredient: ingredientName },
        true,
        false
      );
      setCookingStates(
        response?.types?.length > 0
          ? currentLanguage === 'fr'
            ? response.types.map(item => typeTranslationEnFrMap[item])
            : response.types
          : ['None']
      );
    } catch (err) {
      setCookingStates(['None']);
    }
  };

  const findMaxCarbonObject = () => {
      let n = nextLoadAlternative ? (lowerIngredients?.length + 1) + 1 :  lowerIngredients?.length + 1;
      return fd?.ingredients?.reduce((maxObjects, current) => {
          if (maxObjects.length < n) {
              maxObjects.push(current);
              maxObjects.sort((a, b) => {
                  return (b.carbon_emission / b.ingredient_quantity) - (a.carbon_emission / a.ingredient_quantity);
              });
          } else {
              const minMaxObject = maxObjects[maxObjects.length - 1];
              if ((current.carbon_emission / current.ingredient_quantity) > (minMaxObject.carbon_emission / minMaxObject.ingredient_quantity)) {
                  maxObjects.pop();
                  maxObjects.push(current);
                  maxObjects.sort((a, b) => {
                      return (b.carbon_emission / b.ingredient_quantity) - (a.carbon_emission / a.ingredient_quantity);
                  });
              }
          }
          return maxObjects;
      }, []);
  }

  const translationDicts = {
      fr: FrTranslation,
      // es: EsTranslation,
      // pt: PtTranslation,
      // zh: ZhTranslation,
      // Add other languages here
    };

  const translateIngredientName = (ingredientName, currentLanguage) => {
      if (!ingredientName || typeof ingredientName !== 'string') return ingredientName;
      if (currentLanguage === 'en') return ingredientName;
      const translationDict = translationDicts[currentLanguage];
      if (!translationDict) return ingredientName;
      const alt = ingredientName?.toLowerCase();
      const exactMatch = Object.entries(translationDict).find(
        ([key]) => key.toLowerCase() === alt
      );
      if (exactMatch) {
        return Array.isArray(exactMatch[1]) ? exactMatch[1][0] : exactMatch[1];
      }
      // fallback
      const fuzzyMatch = Object.entries(translationDict).find(
        ([key]) => key.toLowerCase().includes(alt)
      );
      return fuzzyMatch
        ? (Array.isArray(fuzzyMatch[1]) ? fuzzyMatch[1][0] : fuzzyMatch[1])
        : ingredientName;
    };

  const getLowerIngredients = async () => {
    if(!fd.name) {
      toast.error(t("PleaseEnterMealName"));
      return
    }

    const sortedIngredients = [...(fd?.ingredients || [])]
      .filter(ing => ing?.ingredient_id?.name)
      .sort((a, b) =>
        (b.carbon_emission / b.ingredient_quantity) - (a.carbon_emission / a.ingredient_quantity)
      );

    if (sortedIngredients.length === 0) {
      toast.info(t("No more alternative ingredients available"));
      return
    }

    setIsAlternativeLoading(true)

    // Collect IDs of all ingredients currently in the recipe for backend exclusion
    const recipeIngredientIds = (fd?.ingredients || [])
      .map(ing => ing?.ingredient_id?.id)
      .filter(Boolean);

    for (const maxCEObject of sortedIngredients) {
      const ingredientName = maxCEObject?.ingredient_id?.name;
      const ingredientId = maxCEObject?.ingredient_id?.id;

      const alreadyProcessed = lowerIngredients.some(
        li => li.original_ingredient === ingredientName || li.original_id === ingredientId
      );
      if (alreadyProcessed || failedAlternativesRef.current.has(ingredientName)) {
        continue;
      }

      // Track extra exclusions for this specific ingredient across retries
      const localExcludedIds = new Set(recipeIngredientIds);
      const maxRetries = 3;
      let found = false;

      for (let attempt = 0; attempt < maxRetries; attempt++) {
        try {
          let requestIngredient = `${ingredientName}:${maxCEObject.carbon_emission / maxCEObject.ingredient_quantity || maxCEObject.converted_quantity}`
          let lowerIngredientResponse = await request.get("carbon-footprints/ingredients/get-recommended-alternatives", {
            ingredients: requestIngredient,
            recipe_name: fd.name,
            exclude_ingredient_ids: [...localExcludedIds]
          }, true, false);
          let newIngredient = lowerIngredientResponse?.alternatives?.find(i => (i?.original_ingredient === ingredientName))

          if(newIngredient) {
            const altName = newIngredient?.alternative_ingredient?.toLowerCase();
            const altId = newIngredient?.alternative_id;
            const isAlreadyInRecipe = fd.ingredients.some(
              ing => ing?.ingredient_id?.id === altId || ing?.ingredient_id?.name?.toLowerCase() === altName
            );
            if(isAlreadyInRecipe) {
              // Add this alternative to exclusion set and retry
              if(altId) localExcludedIds.add(altId);
              continue;
            }

            const matchingElement = translateIngredientName(newIngredient?.alternative_ingredient,currentLanguage);
            setLowerIngredients((prev => ([...prev, {...newIngredient, unit: (maxCEObject?.converted_unit || maxCEObject?.ingredient_unit), alternative_ingredient: matchingElement, unit_alternative_co2_impact_per_kg: maxCEObject.converted_unit == 'g' || maxCEObject.ingredient_unit == 'g' ?  newIngredient?.alternative_co2_impact_per_kg / 1000 : newIngredient?.alternative_co2_impact_per_kg, alternative_co2_impact_per_kg: newIngredient?.alternative_co2_impact_per_kg * (maxCEObject?.ingredient_quantity || maxCEObject?.converted_quantity) , ingredient_quantity: (maxCEObject?.converted_quantity || maxCEObject?.ingredient_quantity), original_co2_impact_per_kg: newIngredient?.original_co2_impact_per_kg * (maxCEObject?.ingredient_quantity || maxCEObject?.converted_quantity) }])));
            setIsAlternativeLoading(false)
            setIsLoadAlternative(false)
            found = true;
            return
          } else {
            break;
          }
        } catch (error) {
          break;
        }
      }

      if(!found) {
        failedAlternativesRef.current.add(ingredientName);
      }
    }

    // All ingredients exhausted
    toast.info(t("No more alternative ingredients available"));
    setIsAlternativeLoading(false)
    setIsLoadAlternative(false)
    setAllAlternativesExhausted(true)
  }

  function getColorBasedOnCarbonEmission(carbonEmission) {
    let carbonValue = (parseFloat(carbonEmission)/fd.servings) * 1000
    
    if (!carbonEmission || !fd.type) {
      return {color: "#65a700", offset: 0}
    }

    // Recalculate total weight dynamically from current ingredients so that
    // any change to ingredient quantities is immediately reflected in the label.
    const currentTotalWeightInKg = (fd.ingredients || []).reduce(
      (acc, ing) => acc + parseFloat(ing?.ingredient_quantity || 0), 0
    );
    const dynamicPortionWeight = currentTotalWeightInKg
      ? (currentTotalWeightInKg * 1000) / (fd.servings || 1)
      : null;
    // Fall back to the reference weight of the category when no ingredient weight is available
    // (e.g. no ingredients added yet) so the buffet scaling rule can still apply.
    const referenceWeight = REFERENCE_PORTION_WEIGHTS[fd.type] ?? 150;
    const portionWeight = dynamicPortionWeight ??
      (fd.service_type && fd.service_type !== 'plated' ? referenceWeight : null);
    
    const thresholds = portionWeight 
      ? calculateDynamicThresholds(fd.type, fd.service_type, portionWeight)
      : null;

    if (thresholds) {
      if (carbonValue <= thresholds.excellent) {
        return {color: "#65a700", offset: 0};
      }
      if (carbonValue > thresholds.excellent && carbonValue <= thresholds.good) {
        return {color: "#a4f500", offset: 25};
      }
      if (carbonValue > thresholds.good && carbonValue <= thresholds.average) {
        return {color: "#ffc300", offset: 50};
      }
      if (carbonValue > thresholds.average && carbonValue <= thresholds.poor) {
        return {color: "#ff1d00", offset: 75};
      }
      if (carbonValue > thresholds.poor) {
        return {color: "#890500", offset: 100};
      }
    }

    if (((fd.type === 'starters' || fd.type === 'desserts') && carbonValue <= 200) || (fd.type === 'mainDishes' && carbonValue <= 500)) {
      return {color: "#65a700", offset: 0};
    }
    if (((fd.type === 'starters' || fd.type === 'desserts') && (carbonValue > 200 && carbonValue <= 400)) || (fd.type === 'mainDishes' && (carbonValue > 500 && carbonValue <= 1000))) {
      return {color: "#a4f500", offset: 25};
    }
    if (((fd.type === 'starters' || fd.type === 'desserts') && (carbonValue > 400 && carbonValue <= 600)) || (fd.type === 'mainDishes' && (carbonValue > 1000 && carbonValue <= 1500))) {
      return {color: "#ffc300", offset: 50};
    }
    if (((fd.type === 'starters' || fd.type === 'desserts') && (carbonValue > 600 && carbonValue <= 800)) || (fd.type === 'mainDishes' && (carbonValue > 1500 && carbonValue <= 2000))) {
      return {color: "#ff1d00", offset: 75};
    }
    if (((fd.type === 'starters' || fd.type === 'desserts') && carbonValue > 800) || (fd.type === 'mainDishes' && carbonValue > 2000)) {
      return {color: "#890500", offset: 100};
    }
    
    return {color: "#65a700", offset: 0}
  };

  function getSum(france_check = true) {
    let CO2Total = (fd.ingredients || []).reduce(
      (previousValue, currentValue) => {
        let ce_value = ((currentValue.country === 'France' && france_check) ? (currentValue.carbon_emission * 0.90)?.toFixed(3) : currentValue.carbon_emission?.toFixed(3)) || 0;
        return previousValue + parseFloat(ce_value || 0)
      },
      0
    );
    return CO2Total
  };

  useEffect(async () => {
    if(selectedRestaurantId) {
    let payload = {
      limit: 999999999,
      page: 1,
    };
    let response = await request.get("carbon-footprints/ingredients", payload, true, false);
    setIngredients(response.cf_ingredients);
  }
  if(is_demo) {
    setIngredients(dummyIngredients.cf_ingredients)
  }
  }, [is_demo, selectedRestaurantId]);

  const handleCookingMethodologyChange = async (e, ingredient) => {
    const newMethodology = e.target.value;
    setSelectedCookingState(newMethodology);

      const newIngredientResponse = await request.get("carbon-footprints/ingredients", {
        search: ingredient.ingredient_id.name,
        type: currentLanguage == 'fr' ? typeTranslationFrENMap[newMethodology]  : newMethodology,
      });   
      
      // Check if cf_ingredients exists and has items
      if (!newIngredientResponse.cf_ingredients || newIngredientResponse.cf_ingredients.length === 0) {
        setError(t("No ingredients found with that name of cooking methadology."));
        return;
      }
      
      const updatedIngredient = {...newIngredientResponse.cf_ingredients[0], carbon_emission: newIngredientResponse.cf_ingredients[0]?.climate_change};

      const updatedIngredients = fd.ingredients.map((ing) => {
        if (ing.ingredient_id.id === ingredient.ingredient_id.id) {
          return { carbon_emission: updatedIngredient.carbon_emission,
            converted_quantity: updatedIngredient.format,
            converted_unit: updatedIngredient.unit,
            cooking_state: updatedIngredient.cooking_state,
            country: updatedIngredient.country,
            image_path: updatedIngredient.image_path,
            ingredient_cost: updatedIngredient.cost_excl_tax,
            ingredient_id: {
              id: updatedIngredient.id,
              name: updatedIngredient.name,
              unit: updatedIngredient.unit
            },
            ingredient_quantity: updatedIngredient.format,
            ingredient_unit: updatedIngredient.unit,
            is_local: false,
            nutritive_value: updatedIngredient.nutritive_value,
            seasonal_months: updatedIngredient.seasonal_months,
            source: updatedIngredient.source
           }; 
        }
        return ing; 
    });
      setFd({ ...fd, ingredients: updatedIngredients });
    };

  useEffect(() => {
    setFd({
      allergens: [],
      ingredients: [],
      meals: [],
      service_type: "plated",
    });
    setFiles([])
    setIsSubmitDisabled(true);
    setIsUploaded(false);
    setAllAlternativesExhausted(false);
    failedAlternativesRef.current = new Set();
  }, [show]);

  useEffect(() => {
    if (!state.selectedMeal) {
      setFd({ allergens: [], ingredients: [], servings: "", meals: [], service_type: "plated" });
      return;
    }
    const newSelectedMeal = cloneDeep(state.selectedMeal);
    prevTotalWeight.current = newSelectedMeal?.weight_in_kg
    prevFdQuantity.current = state.selectedMeal?.format ?? 0;
    let selIngredients = ingredients?.filter(a => state?.selectedMeal?.carbon_footprint_ingredients?.some(b => b.id === a.id)) || [];
    setSelectedIngredients((p) => [...p, ...selIngredients])
    const manipulatedIngredients = newSelectedMeal?.carbon_footprint_ingredients?.map(
      (ingredient) => {
        let ing_unit = ingredient?.CarbonFootprintIngredientMeal?.ingredient_unit
        return {
          ingredient_id: {
            id: ingredient.id,
            name:
              ingredient.name,
              unit: ing_unit === 'kg' || ing_unit === 'l' ? 'g' : ing_unit,
  
          },
          ingredient_cost: ingredient?.CarbonFootprintIngredientMeal?.ingredient_cost,
          ingredient_unit: ing_unit,
          is_local: Boolean(ingredient?.CarbonFootprintIngredientMeal?.ingredient_is_local),
          ingredient_quantity: ingredient.CarbonFootprintIngredientMeal.ingredient_quantity,
          source: ingredient.source,
          seasonal_months: ingredient.seasonal_months,
          country: ingredient.country,
          cooking_state: ingredient.cooking_state,
          type: ingredient.type,
          nutritive_value: ingredient.nutritive_value,
          image_path: ingredient.image_path,
          carbon_emission: ingredient.CarbonFootprintIngredientMeal.ingredient_co2_impact,
          converted_unit: ingredient.CarbonFootprintIngredientMeal.converted_unit,
          converted_quantity: ingredient.CarbonFootprintIngredientMeal.converted_quantity,
        };
      }
    );
    setFd({
      ...fd,
      cost: newSelectedMeal.cost_per_person,
      ...newSelectedMeal,
      service_type: newSelectedMeal.service_type ?? "plated",
      ...(newSelectedMeal.carbon_footprint_ingredients && {
        ingredients: manipulatedIngredients,
      }),
      allergens: state.selectedMeal.allergens.map((a) => a.id),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.selectedMeal]);
  const prevIngredientsRef = useRef(fd.ingredients);
  const skipAlternativeClearRef = useRef(false);
  useEffect(() => {
    if (skipAlternativeClearRef.current) {
      skipAlternativeClearRef.current = false;
    } else if (prevIngredientsRef.current !== fd.ingredients && lowerIngredients.length > 0) {
      setLowerIngredients([]);
      setAlternativeIngredients([]);
      setIsLoadAlternative(true);
      setNextLoadAlternative(false);
      setAllAlternativesExhausted(false);
      failedAlternativesRef.current = new Set();
    }
    prevIngredientsRef.current = fd.ingredients;
  }, [fd.ingredients]);

  useEffect(() => {
    setIsSubmitDisabled(false);
  }, [fd]);

  let dummyDatasource = useMemo(
    () =>
      dummyIngredients.cf_ingredients.map((m) => ({
        value: m.name,
        label: m.name,
        name: m.name,
        item_id: m.id,
      })),
    []
  );

  const onAllergenClick =
    ({ id }) =>
    () => {
      let newAllergens = cloneDeep(fd.allergens);
      if (newAllergens.includes(id)) {
        newAllergens = newAllergens.filter((allergenId) => allergenId !== id);
      } else {
        newAllergens = [...newAllergens, id];
      }
      setFd({
        ...fd,
        allergens: newAllergens,
      });
    };

  const onSelectionChange =
    (type) => {
      return ({ id }) => setFd({ ...fd, [type]: id })
    };

  const onTextChange = ({ target: { name, value, type } }) => {
    let newValue = value;
    if (name === 'selling_price_per_person') {
      newValue = formatInput(value)
    }
    setFd({ ...fd, [name]: newValue });
  };

  const importModalCloseHandler = (value) => {
    setImportDocument(value);
    if(isRestaurantLoaded && !hasRetaurants) {
      let file = storage.getItem("uploaded_file")
      let meal;
      if(file) {
        switch(file) {
          case 'pdf':
            meal = carbon_footprint_recipes.cf_meals.find((r) => r.item_id === '0f13bc7e-957c-45fc-b7b2-52b59b4220a5');
            break;
          case 'jpg':
            meal = carbon_footprint_recipes.cf_meals.find((r) => r.item_id === '0727989d-d0b2-4899-bfcf-0bd6f4498534');
            break;
          case 'docx':
            meal = carbon_footprint_recipes.cf_meals.find((r) => r.item_id === '1d2eb03a-de78-4c88-bd0b-6994fd0dea08');
            break;
          case 'xlsx':
            meal = carbon_footprint_recipes.cf_meals.find((r) => r.item_id === 'a5c7aad0-5709-484f-b16b-71104936c5e5');
            break;
          default:
            meal = {};
      }
      storage.removeItem("uploaded_file")
    }
      let newIngredients = meal?.carbon_footprint_ingredients?.map(item => {
        return {
          carbon_emission: item.climate_change,
          converted_unit: null,
          ingredient_cost: null,
          ingredient_unit: item?.CarbonFootprintIngredientMeal?.ingredient_unit,
          ingredient_id: {
            id: item.id,
            name: item.name,
            unit: "kg",
          },
          ingredient_quantity: item?.CarbonFootprintIngredientMeal?.ingredient_quantity,
          is_local: true
        }
      })
      setFd({...meal, ingredients: newIngredients});
    }
    
}

  const onSubmit = async (ev) => {
    ev.preventDefault();

    if (isRestaurantLoaded && !hasRetaurants) {
      setIsUploaded(true);
      return;
    }

    if (selectedRestaurantId === "") {
      setSampleRestaurantModal(true);
      return;
    }

    const missingFields = [];
    if (!fd.name) missingFields.push(t("MealName"));
    if (!fd.servings) missingFields.push(t("Servings"));
    if (!fd.type) missingFields.push(t("MealCategory"));
    if (!fd.service_type) missingFields.push(t("ServiceType"));
    if (missingFields.length > 0) {
      toast.error(`${t("Please fill in the required fields")}: ${missingFields.join(", ")}`);
      return;
    }

    try {
      setIsSubmitDisabled(true);
      setLoading(true);
      const { cost, selling_price_per_person, ...rest } = fd;
      let fdIngredients =
        fd.ingredients
          ?.map((i) => {
          return  {
            ingredient_id: i.ingredient_id?.id,
            ingredient_unit: i.ingredient_unit,
            ingredient_quantity: i.ingredient_quantity,
            ingredient_cost: i.ingredient_cost,
            ingredient_co2_impact: i?.carbon_emission,
            ingredient_is_local: i?.is_local,
            converted_unit: i.converted_unit,
            converted_quantity: i.converted_quantity,
          }}
          )
          .filter((i) => i.ingredient_id) || null;
      let ingredients = [...fdIngredients];

      const format =
        fd?.type === "intermediate-recipe" ? parseFloat(fd.format) : undefined;

        const total_weight_in_kg = fd?.ingredients?.reduce((a, b) => {
          return a + parseFloat(b?.ingredient_quantity || 0)
        }, 0)
      const payload = {
        ...omit(rest, ["value", "label", "meals", "ingredients", "restaurant"]),
        carbon_footprint_ingredients: alternativeIngredients.length ? alternativeIngredients : ingredients,
        restaurant_id: selectedRestaurantId,
        reference_number: fd.reference_number || null,
        cost_per_person: cost,
        category: fd.category,
        price_per_person: +fd.selling_price_per_person,
        co2_impact_in_kg: fd?.ingredients?.reduce((a, b) => a + b?.carbon_emission, 0),
        weight_in_kg: total_weight_in_kg,
        total_price: +parseFloat(
          fd.selling_price_per_person * fd.servings
        ).toFixed(2),
        is_weight_alert: total_weight_in_kg !== prevTotalWeight.current ? (total_weight_in_kg / fd?.servings) > 1.5 ?  true : false : fd.is_weight_alert,
        is_seasonal_alert: fd.is_seasonal_alert === false ? false : (fd.ingredients?.map(ingredient => {
          if(ingredient?.seasonal_months === null) {
            return false
          }
         return ingredient.seasonal_months?.some((month => month?.toLowerCase() === currentMonth.toLowerCase()))
        }
        )).some(item => item === false) ? true : null,
        margin_per_person: +(selling_price_per_person - cost) || null,
        total_margin: +parseFloat(
          fd.selling_price_per_person * fd.servings - cost * fd.servings
        ).toFixed(2),
        format,
        unit: fd?.unit,
      };
      if (!state.selectedMeal) {
        const result = await request.post("/carbon-footprint-meals", payload);
        
        if ([200, 201].includes(result.status)) {
          fileUpload(await result.json());
          setLoading(false)
          setAlternativeIngredients([])
          setLowerIngredients([])
          setIsLoadAlternative(true)
          setIsSwitched(false)
          setSelectedRowIndex(null)
          return;
        }
        const err = await result.json()
        setLoading(false);
        setSelectedRowIndex(null)
        toast.error(t(err.msg[0]))
        throw Error(result);
      }
      delete payload.id;
      delete payload.provider_name;
      delete payload.image_path;
      delete payload.createdAt;
      delete payload.updatedAt;
      delete payload.item_id;
      delete payload.is_external;

      const resultQuery = await request.patch(
        `/carbon-footprint-meals/${state.selectedMeal.id}`,
        payload
      );

      if ([200].includes(resultQuery.status)) {
        fileUpload(await resultQuery.json(), false);
        setAlternativeIngredients([])
        setLowerIngredients([])
        setIsLoadAlternative(true)
        setIsSwitched(false)
        setSelectedRowIndex(null)
        return;
      }
      const err = await resultQuery.json()
      setLoading(false);
      setSelectedRowIndex(null)
      toast.error(t(err.msg[0]))

      // throw Error(resultQuery);
    } catch (error) {
      setIsSubmitDisabled(false);
    }
  };

  const fileUpload = async (meal, create = true) => {
    if (!acceptedFiles.length) {
      onRowAdded(meal, create);
      setFd({ ...fd, allergens: [] });
      setLoading(false);
      setIsSubmitDisabled(false);
      setIsUploaded(true);
      return;
    }
    try {
      let formData = new FormData();
      formData.append("image", acceptedFiles[0]);
      await request.patchFile(`/carbon-footprint-meals/upload-image/${meal.id}`, formData);

      setIsUploaded(true);
      onRowAdded(meal, create);
      setLoading(false);
      setFd({ ...fd, allergens: [] });
    } catch (error) {
      setError(DEFAULT_ERROR_MESSAGE);
    } finally {
      setIsSubmitDisabled(false);
    }
  };

  const onRemoveFile = (file, i) => () => {
    const newFiles = [...files];
    newFiles.splice(newFiles.indexOf(file), 1);
    setFiles(newFiles);
  };

  const handleChange = (selectedOption, i) => {
    let newIngredients = cloneDeep(fd.ingredients);
    const ingredient = newIngredients[i];

    ingredient['country'] = selectedOption.value;
    newIngredients[i] = ingredient
    setFd({ ...fd, ingredients: newIngredients });  
  }; 

  const onAddIngredientItem = async (ev) => {
    const restaurantDetails = await request.get(`restaurants/${selectedRestaurantId}`);

    setFd({
      ...fd,
      ingredients: [
        ...(fd.ingredients || []),
        {
          ...INGREDIENT_INITIAL,
          ...(ev.id && {
            ingredient_id: {
              id: ev.id,
              name: ev.name,
              unit_price: ev.unit_price,
              unit: ev.unit,
              carbon_emission: ev.carbon_emission,
              
              seasonal_months: ev.seasonal_months
            },
          }),
        },
      ],
    });
  };

  const countries = COUNTRY_CODE_OPTIONS.map(country => ({
    value: country.value,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <WorldFlag code={country.id} style={{ width: '20px', marginRight: '10px' }} />
        {country.label}
      </div>
    )
  }));

  // Custom Option component
const CountryOption = (props) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <span style={{ marginRight: 10 }}>
        <WorldFlag code={data.id} style={{ width: '20px', marginRight: '10px' }} />
      </span>
      {data.label}
    </components.Option>
  );
};

const getCountry = (country) => {
  return COUNTRY_CODE_OPTIONS.find(c => c.value === country)
}

// Custom Single Value component
const CountrySingleValue = (props) => {
  const { data } = props;
  return (
    <components.SingleValue {...props}>
      <span style={{ marginRight: 10 }}>
        <WorldFlag code={data.id} style={{ width: '20px', marginRight: '10px' }} />
      </span>
      {data.label}
    </components.SingleValue>
  );
};

  const updateRecipe = async(i) => {
    if(is_demo) {
      toast.success(t("Recipe updated successfully"))
      setLowerIngredients(lowerIngredients.map(item => ({...item, alternative_ingredient: item.original_ingredient, original_ingredient: item.alternative_ingredient})))
      return
    }

    if(lowerIngredients.length) {
      const updatedIngredients = fd.ingredients.map(ing => {
        if (lowerIngredients[i]?.original_ingredient === ing?.ingredient_id?.name) {
          return { 
            ingredient_id: lowerIngredients[i].alternative_id,
            ingredient_unit: lowerIngredients[i].unit,
            ingredient_quantity: lowerIngredients[i]?.ingredient_quantity,
            ingredient_cost: null,
            ingredient_co2_impact: lowerIngredients[i].alternative_co2_impact_per_kg,
            ingredient_is_local: false,
            converted_unit: null,
            converted_quantity: null
          }
        }
        return {
          ingredient_id: ing?.ingredient_id?.id,
          ingredient_unit: ing?.ingredient_unit,
          ingredient_quantity: ing?.ingredient_quantity,
          ingredient_cost: null,
          ingredient_co2_impact: ing?.carbon_emission,
          ingredient_is_local: ing?.is_local,
          converted_unit: null,
          converted_quantity: null
        }
      })
      if(updatedIngredients?.length) {
          const matchedItemIndex = fd.ingredients.findIndex(ing => ing.ingredient_id?.name === lowerIngredients[i].original_ingredient);
          if(matchedItemIndex === -1) {
            return
          }
          setIsAlternativeLoading(true)
          setAlternativeIngredients(updatedIngredients)
          let fdIngredients = cloneDeep(fd.ingredients);
          setLowerIngredients(lowerIngredients.map((item, index) => {
            if(index == i) {
              return {
                ...item, 
                alternative_id: item.original_id, 
                original_id: item.alternative_id,
                alternative_ingredient: item.original_ingredient, 
                original_ingredient: item.alternative_ingredient, 
                alternative_co2_impact_per_kg: (item.original_co2_impact_per_kg), original_co2_impact_per_kg: item.alternative_co2_impact_per_kg, 
                alternative_id: item.original_id, original_id: item.alternative_id, 
                alternative_country: item.original_country, original_country: item.alternative_country,
                alternative_seasonal_months: item.original_seasonal_months, original_seasonal_months: item.alternative_seasonal_months, 
                alternative_nutritive_value: item.original_nutritive_value, original_nutritive_value: item.alternative_nutritive_value,
                alternative_image_path: item.original_image_path, original_image_path: item.alternative_image_path
              }
            }
            return item
          }))
          const ingredient = { 
            carbon_emission: lowerIngredients[i].alternative_co2_impact_per_kg,
            converted_quantity: null,
            converted_unit: null,
            ingredient_cost: null,
            ingredient_id: {
                    id: lowerIngredients[i].alternative_id,
                    name: lowerIngredients[i].alternative_ingredient,
                    unit: fd.ingredients[matchedItemIndex].ingredient_unit
            },
            ingredient_quantity: lowerIngredients[i].ingredient_quantity,
            ingredient_unit: lowerIngredients[i].unit,
            ingredient_is_local: false,
            country: lowerIngredients[i]?.alternative_country,
            seasonal_months: lowerIngredients[i]?.alternative_seasonal_months,
            nutritive_value: lowerIngredients[i]?.alternative_nutritive_value,
            image_path: lowerIngredients[i]?.alternative_image_path
          }
  
          fdIngredients[matchedItemIndex] = ingredient
            // setAlternativesIngredients([])
            skipAlternativeClearRef.current = true;
            setFd({ ...fd, ingredients: fdIngredients })
            setIsAlternativeLoading(false)
      }
    }
  }

  const calculateCost = (ingredient) => {
    const { unit_price, unit } = ingredient?.ingredient_id || {};
    const {
      ingredient_unit,
      ingredient_quantity,
      converted_unit,
      converted_quantity,
    } = ingredient;
    if (["g", "kg", "mg", "lb", "l", "ml", "m", "mm"].includes(ingredient_unit)) {
      try {
        const convertQuantity = converted_quantity ?? ingredient_quantity;
        const convertFrom = converted_unit ?? ingredient_unit;
        const convertTo = unit ?? converted_unit ?? ingredient_unit;
        const convertedValue =
          convert(convertQuantity, convertFrom).to(convertTo) || 0;

        ingredient.ingredient_cost = (parseFloat(unit_price * convertedValue)).toFixed(2);
        ingredient.ingredient_quantity = roundToTwo(convertedValue);
        return ingredient
      } catch (error) {
        ingredient.ingredient_cost = roundToTwo(
          ingredient_quantity * unit_price || 0
        );
        return ingredient
      }
    } else {
      ingredient.ingredient_cost = roundToTwo(
        ingredient_quantity * unit_price || 0
      );
      return ingredient
    }
  };

  const formatInput = (input) => {
    // Allow only digits, dots, and commas in the input
    const sanitizedInput = input.replace(/[^0-9.,]/g, '');

    // Replace commas with dots, allowing both as decimal points
    let normalizedInput = sanitizedInput.replace(',', '.');

    // Check if there's already a dot present, and if so, remove any additional dots
    const parts = normalizedInput.split('.');

    if (parts.length > 2) {
        // If there are multiple dots, keep the first part and join the rest without additional dots
        normalizedInput = parts[0] + '.' + parts.slice(1).join('');
    }

    return normalizedInput;
};


  const onIngredientTextBoxChange =
    (i) =>
   async ({ target: { name, value: val } }) => {
    if(name == "alternative_ingredient_quantity") {
      setLowerIngredients((prev) => {
          return prev.map((item, idx) => {
            if(idx == i) {
              return {...item, 
                ingredient_quantity: parseFloat(val), 
                alternative_co2_impact_per_kg: parseFloat(val) * item.unit_alternative_co2_impact_per_kg}
            }
            return item
          })
      })
      return
    }
    let value = val
    if(name = 'ingredient_quantity') {
      value = formatInput(val)
    }
     
      // let value = +val.replace(/[^\d.]/, "");

      // if (!(+value !== 0) && val !== "") {
      //   return;
      // }
      if (val === "") {
        value = "";
      }

      
   

      if (name === "meal_quantity") {
        // prevFdQuantity.current =
        //   fd.meals[i]?.format > 0 ? fd.meals[i]?.format : 1;
        let updatedIngredients = fd.meals[i].ingredients.map((item) => {
          // let  providerIngredient = ingredients.find(ing => ing.id === item.id)
          // let ratio =
          //   value === ""
          //     ? 0 / prevFdQuantity.current
          //     : +value / prevFdQuantity.current;
          return {
            ...item,
            CarbonFootprintIngredientMeal: {
              ...item.CarbonFootprintIngredientMeal,
              ingredient_cost: parseFloat(item.cost_excl_tax * (value * item.CarbonFootprintIngredientMeal.ingredient_quantity))
            },
          };
        });
        prevFdQuantity.current = parseFloat(value);
        fd.meals[i].format = value;
        fd.meals[i].ingredients = updatedIngredients;
        return setFd({ ...fd });
      }
      let newIngredients = cloneDeep(fd.ingredients);
      const ingredient = newIngredients[i];
      ingredient[name] = value;
      const newIngredient = await request.get(`carbon-footprints/ingredients/${ingredient.ingredient_id.id}`)

      if (name === "ingredient_quantity") {
        let carbon_unit_value = (ingredient.converted_unit === 'g') ? (newIngredient?.climate_change || 0) / 1000 : (newIngredient?.climate_change || 0)
        let unit_value = (ingredient.converted_unit === 'g') ? value/1000 : value

        ingredient["converted_quantity"] = ingredient.converted_unit === 'g' ? value : null;
        ingredient["ingredient_quantity"] = unit_value;
        ingredient["carbon_emission"] = (parseFloat(value) *  carbon_unit_value);
        ingredient["ingredient_cost"] =  (parseFloat(value * newIngredient?.cost_excl_tax));
      }

      // const updatedIngredient = calculateCost({...ingredient});
      // newIngredients = newIngredients.map(i => {
      //       if (i.ingredient_id.id === updatedIngredient.ingredient_id.id) {
      //        return {...updatedIngredient}
      //       }
      //       return i
      //     })
      newIngredients[i] = ingredient
      setFd({ ...fd, ingredients: newIngredients });
    };

  const onIngredientSelectBoxChange =
    (i) =>
     (type) =>
    async ({ id, unit_price, name: ingName, french, ingredient_unit,carbon_emission, unit, ingredient_id }) => {
      if(type === "alternative_ingredient_unit") {
        setLowerIngredients(prev => prev.map((item, idx) => {
          if(idx == i) {
            return {
              ...item,
              unit: id,
              ingredient_quantity: id === "g" ? item.ingredient_quantity * 1000 : (id === "kg" || id === "l") ? item.ingredient_quantity / 1000 : item.ingredient_quantity,
              unit_alternative_co2_impact_per_kg: id === "g" ? item.unit_alternative_co2_impact_per_kg / 1000 : (id === "kg" || id === "l") ? item.unit_alternative_co2_impact_per_kg * 1000 : item.unit_alternative_co2_impact_per_kg
            }
          }
          return item
        }))
        return
      }

      let name = ingName?.includes("Get an estimation for ") || ingName?.includes("Obtenez une estimation pour ") ? ingName?.split(french ? "pour " : "for ")[1].trim() : ingName
      let updatedType = type === "ingredient_id" ? "id" : type
      let newIngredients = cloneDeep(ingredients);
      let fdIngredients = cloneDeep(fd.ingredients);
      let fdCarbonIngredients = cloneDeep(fd.carbon_footprint_ingredients) || [];
      let ingredient = fdIngredients[i]
      let prevIngredient = fd.ingredients[i]
      // const { data: restaurantDetails } = await request.get(`restaurants/${selectedRestaurantId}`);
      
      const restaurantDetails = await request.get(`restaurants/${selectedRestaurantId}`);
      const restaurantCountry = restaurantDetails.country;
      if(type === "ingredient_id") {
        if(isRestaurantLoaded && !hasRetaurants) {
            let ingredient = ingredients.find(item => item.id === id)
            if (!ingredient) return;
            ingredient["ingredient_id"] = { id: ingredient.id, name: ingredient.name, unit: ingredient.unit };
            ingredient["ingredient_unit"] = ingredient.unit;
            ingredient["converted_unit"] = ingredient.unit;
            ingredient["carbon_emission"] = ingredient.climate_change;
            ingredient["ingredient_quantity"] = ingredient?.format || 1;
            fdIngredients[i] = ingredient
            setFd({ ...fd, ingredients: fdIngredients });
            return
        }else {
          if(!ingredient_id?.id && !french) {
            const createdIngredient = await request.post("/carbon-footprints/ingredients", { 
              name: ingredient_id?.name?.trim(),
              climate_change: carbon_emission,
              source: "CHATGPT"
            });
            const res = await createdIngredient.json();
            let updatedIngredient = {
              carbon_emission,
              ingredient_quantity: 1,
              ingredient_unit: "kg",
              converted_unit: "g",
              converted_quantity: 1000,
              source: "CHATGPT",
              ingredient_id: {
                id: res.id,  
                name: res.name,
                unit: "g",
              },
              country: restaurantCountry
            }
      
            fdIngredients[i] = updatedIngredient
            fdCarbonIngredients[i] = {
              CarbonFootprintIngredientMeal : {
                ingredient_unit: "kg",
                ingredient_quantity: 1,
                ingredient_cost: 0,
                converted_unit: null,
                converted_quantity: null,
                ingredient_co2_impact: carbon_emission,
                ingredient_is_local: false,
              },
              category: null,
              climate_change: carbon_emission,
              country: null,
              format: 1,
              id: res.id,
              image_path: null,
              name: null,
              nutritional_value: null,
              unit: null,
              seasonal_months: null
            };
            setFd({ ...fd, ingredients: fdIngredients, carbon_footprint_ingredients: fdCarbonIngredients });
            return
          }else if(!ingredient_id?.id && french) {
            const trimmedName = name?.trim()
            const translationKey = Object.keys(translations).find(k => k.toLowerCase() === trimmedName?.toLowerCase())
            const searchInput = translationKey ? translations[translationKey] : undefined
            let response
            if(!searchInput) {
               response = await request.get("carbon-footprints/ingredients", { search: name?.trim() }, true, false);
              if(response.cf_ingredients.length > 0) {
                response = response.cf_ingredients.find(ing => ing.source !== 'CHATGPT') || response.cf_ingredients[0]
              }else {
                const createdIngredient = await request.post("/carbon-footprints/ingredients", {
                  name: ingredient_id?.name?.trim(),
                  climate_change: carbon_emission,
                  source: "CHATGPT"
                });
                response = await createdIngredient.json();
              }

              let updatedIngredient = {
                carbon_emission: prevIngredient.converted_unit === 'g' ?  (carbon_emission/1000) * prevIngredient.converted_quantity : prevIngredient.ingredient_unit === 'g' ? (carbon_emission/1000) * prevIngredient.ingredient_quantity : carbon_emission * prevIngredient.ingredient_quantity,
                ingredient_quantity: prevIngredient.ingredient_quantity,
                ingredient_unit: prevIngredient.ingredient_unit,
                converted_unit: prevIngredient.converted_unit,
                converted_quantity: prevIngredient.converted_quantity,
                source: response?.source || "CHATGPT",
                ingredient_id: {
                  id: response.id,  
                  name: response.name,
                  unit: prevIngredient.converted_unit || prevIngredient.ingredient_unit,
                },
                country: restaurantCountry

              }
        
              fdIngredients[i] = updatedIngredient
              fdCarbonIngredients[i] = {
                CarbonFootprintIngredientMeal : {
                  ingredient_unit: prevIngredient.ingredient_unit,
                  ingredient_quantity: prevIngredient.ingredient_quantity,
                  ingredient_cost: 0,
                  converted_unit: prevIngredient.converted_unit,
                  converted_quantity: prevIngredient.converted_quantity,
                  ingredient_co2_impact: prevIngredient.converted_unit === 'g' ?  (carbon_emission/1000) * prevIngredient.converted_quantity : prevIngredient.ingredient_unit === 'g' ? (carbon_emission/1000) * prevIngredient.ingredient_quantity : carbon_emission * prevIngredient.ingredient_quantity,
                  ingredient_is_local: false,
                },
                category: null,
                climate_change: carbon_emission,
                country: prevIngredient.country,
                format: 1,
                id: response.id,
                image_path: null,
                name: null,
                nutritional_value: null,
                unit: null,
                seasonal_months: null
              };
              setFd({ ...fd, ingredients: fdIngredients, carbon_footprint_ingredients: fdCarbonIngredients });
              return
            }
            // Search by French name first to find ACCOR/non-CHATGPT ingredients
            const frenchResponse = await request.get("carbon-footprints/ingredients", { search: name?.trim() }, true, false);
            const frenchMatch = frenchResponse.cf_ingredients?.find(ing => ing.name?.toLowerCase() === trimmedName?.toLowerCase() && ing.source !== 'CHATGPT');

            response = await request.get("carbon-footprints/ingredients", { search: searchInput}, true, false);
            let foundIngredient = frenchMatch
              || response.cf_ingredients.find(item => item.name?.toLowerCase() === searchInput?.toLowerCase() && item.source !== 'CHATGPT')
              || response.cf_ingredients.find(item => item.source !== 'CHATGPT')
              || response.cf_ingredients.find(item => item.name?.toLowerCase() === searchInput?.toLowerCase())

            const ingClimateChange = foundIngredient?.climate_change || carbon_emission || 0;
            let ingredient1 = {
              carbon_emission: prevIngredient.converted_unit === 'g' ?  (ingClimateChange/1000) * prevIngredient.converted_quantity : prevIngredient.ingredient_unit === 'g' ? (ingClimateChange/1000) * prevIngredient.ingredient_quantity : ingClimateChange * prevIngredient.ingredient_quantity,
              converted_quantity: prevIngredient.converted_quantity,
              ingredient_quantity: prevIngredient.ingredient_quantity,
              image_path: foundIngredient?.image_path,
              nutritive_value: foundIngredient?.nutritive_value,
              seasonal_months: foundIngredient?.seasonal_months,
              cooking_state: foundIngredient?.cooking_state,
              country: restaurantCountry,
              ingredient_unit: prevIngredient.ingredient_unit,
              converted_unit: prevIngredient.converted_unit,
              source: foundIngredient?.source || "CHATGPT",
              ingredient_id: {
                id: foundIngredient?.id || null,
                name: foundIngredient?.name || searchInput || trimmedName,
                unit: prevIngredient.converted_unit || prevIngredient.ingredient_unit,
              }
            }
            fdIngredients[i] = ingredient1
            setFd({ ...fd, ingredients: fdIngredients });
            return
          }else {
            ingredient = await request.get(`carbon-footprints/ingredients/${id}`);
            ingredient = {...ingredient, is_local: false}
            let obj = ingredient && {
              CarbonFootprintIngredientMeal : {
                ingredient_unit: ingredient.unit,
                ingredient_quantity: ingredient.format,
                ingredient_cost: ingredient.cost_excl_tax,
                converted_unit: ingredient.converted_unit,
                converted_quantity: ingredient.converted_quantity,
                ingredient_co2_impact: ingredient.climate_change,
                ingredient_is_local: false,
              },
              category: ingredient.category,
              climate_change: ingredient.climate_change,
              country: restaurantCountry,
              format: ingredient.format,
              id: ingredient.id,
              image_path: ingredient.image_path,
              name: ingredient.name,
              nutritional_value: ingredient.nutritive_value,
              unit: ingredient.unit,
              seasonal_months: ingredient.seasonal_months
            }
            
            fdIngredients[i] = obj
            setFd({ ...fd, ingredients: fdIngredients });
          }
        }
      }
    

      setSelectedIngredients((prev) => [
        ...prev,
        ingredients.find((i) => i.id === id),
      ]);

      if (ingredient && updatedType !== "ingredient_unit") {
        ingredient[updatedType] = id;
      }
      if (updatedType === "ingredient_unit") {
        // ingredient["converted_unit"] = id;
        // ingredient["ingredient_unit"] = id;
        // ingredient.ingredient_id.unit = id;
        if(((fd.ingredients[i].ingredient_unit === 'kg' || fd.ingredients[i].ingredient_unit === 'l')) && id === 'g') {
          // ingredient["ingredient_quantity"] = ingredient['ingredient_quantity'] * 1000
          ingredient["converted_quantity"] = ingredient['ingredient_quantity'] * 1000
          ingredient["converted_unit"] = id;
        }else if ((fd.ingredients[i].converted_unit === 'g') && (id === 'kg' || id === "l")) {
          ingredient["ingredient_quantity"] = ingredient['converted_quantity'] / 1000
          ingredient["ingredient_unit"] = id;
          ingredient["converted_quantity"] = null
          ingredient["converted_unit"] = null;
        }else if((fd.ingredients[i].ingredient_unit === 'kg' ) && id === 'l') {
          ingredient["ingredient_unit"] = id;
        }else if((fd.ingredients[i].ingredient_unit === 'l' ) && id === 'kg') {
          ingredient["ingredient_unit"] = id;
        }else if(fd.ingredients[i].ingredient_unit === 'g' && !fd.ingredients[i].converted_unit && (id === 'kg' || id === 'l')) {
          ingredient["ingredient_unit"] = id;
          ingredient["ingredient_quantity"] = ingredient['ingredient_quantity'] / 1000;
        }else {
          ingredient["ingredient_unit"] = id;
          ingredient["converted_unit"] = null;
          ingredient["converted_quantity"] = null;
        }
      }

      if (updatedType === "id") {
        ingredient["ingredient_id"] = ingredient_id;
        ingredient["ingredient_unit"] = prevIngredient.ingredient_unit;
        ingredient["converted_unit"] = prevIngredient.converted_unit;
        ingredient["ingredient_quantity"] = prevIngredient.ingredient_quantity;
        ingredient["converted_quantity"] = prevIngredient.converted_quantity;
        ingredient["ingredient_cost"] = ingredient['cost_excl_tax']
        ingredient["carbon_emission"] = prevIngredient.converted_unit === 'g' ?  ((ingredient?.['climate_change'] || 0)/1000) * prevIngredient.converted_quantity : prevIngredient.ingredient_unit === 'g' ? ((ingredient?.['climate_change'] || 0)/1000) * prevIngredient.ingredient_quantity : (ingredient?.['climate_change'] || 0) * prevIngredient.ingredient_quantity
      }

      fdIngredients[i] = ingredient
      setFd({ ...fd, ingredients: fdIngredients, carbon_footprint_ingredients: fdCarbonIngredients });
    };

  const deleteIngredient = (index, type) => () => {
    if (type === "meal") {
      fd.meals.splice(index, 1);
      return setFd({ ...fd });
    }

    const newIngredients = cloneDeep(fd.ingredients);
    newIngredients.splice(index, 1);
    // setSelectedIngredients((prev) => prev.filter((item) => item.id !== ingredient.ingredient_id.id));
    setFd({ ...fd, ingredients: newIngredients });
  };

  const deleteLowerIngredient = (index, type) => () => {
    if (type === "meal") {
      fd.meals.splice(index, 1);
      return setFd({ ...fd });
    }

    const newLowerIngredients = cloneDeep(lowerIngredients);
    newLowerIngredients.splice(index, 1);
    setLowerIngredients(newLowerIngredients);
    if (newLowerIngredients.length === 0) {
      setIsLoadAlternative(true);
      setNextLoadAlternative(false);
    }
  };

  const thumbs = files.map((file) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={file.preview} style={img} alt="..." />
      </div>
    </div>
  ));



  const loadOptions = async (search) => {
    if (!search || search.length < 3 || search === "") {
      return { options: [], hasMore: false };
    }

    try {
      const response = await request.get(
        "meals",
        { search, restaurant_id: selectedRestaurantId },
        true,
        false
      );

      return {
        options: response.meals.map((i) => ({
          ...i,
          value: i.name,
          label: i.name,
        })),
        hasMore: false,
      };
    } catch (error) {
      return { options: [], hasMore: false };
    }
  };

  const createSelectChange = (obj, { action }) => {
    if (action === "select-option") {
      props.setSelectedMeal(obj);
      setMealNameSelectKey(prev => prev + 1);
    }
    if (action === "clear") {
      props.setSelectedMeal(null);
      setFd(prev => ({ ...prev, name: "" }));
      setMealNameSelectKey(prev => prev + 1);
    }
    if (action === "create-option") {
      setFd(prev => ({ ...prev, name: obj.value }));
      setMealNameSelectKey(prev => prev + 1);
    }
  };


  const onLocalCheckboxChange = (i) => {
    const isCurrentlyLocal = fd.ingredients[i]?.is_local;
    setFd({ ...fd, ingredients: fd.ingredients.map((ing, index) => index === i ? { ...ing, is_local: !isCurrentlyLocal, carbon_emission: parseFloat(isCurrentlyLocal ? ing.carbon_emission / 0.95 : 0.95 * ing.carbon_emission) } : ing) })
  }

  const fetchWithTimeout = async (url, options = {}, timeout = 60000) => {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
  
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      clearTimeout(id);
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.warn("Fetch request timed out");
      }
      throw error;
    }
  };

  // API returns single-serving quantities; multiply by servings to get totals stored in state.
  const setRecipe = (randomRecipe) => {
    const servings = fd.servings || 1;
    setFd({
      ...fd,
      ingredients: randomRecipe.recipe.map(item => ({
        carbon_emission: item?.co2_impact_per_kg * item?.weight_in_kg * servings,
        converted_quantity: (item?.unit === 'g' || item?.unit === 'ml') ? item?.weight_in_kg * servings : null,
        converted_unit: (item?.unit === 'g' || item?.unit === 'ml') ? item?.unit : null,
        ingredient_cost: item?.cost_excl_tax,
        seasonal_months: item?.seasonal_months,
        nutritive_value: item?.nutritive_value,
        image_path: item?.image_path,
        country: item?.country,
        cooking_state: item?.cooking_state,
        is_recipe: item.is_recipe,
        ingredient_id: {
          id: item?.id,
          name: item?.name,
          unit: item?.unit
        },
        ingredient_unit: item?.unit,
        ingredient_quantity: item?.weight_in_kg * servings,
        is_local: false
      }))
    });
  }

  const getRandomRecipe = async () => {
    if (hasRetaurants && !isRestaurantLoaded) {
      const randomIndex = Math.floor(Math.random() * 16);
      const randomRecipe = carbon_footprint_recipes.cf_meals[randomIndex];
      let newIngredients = randomRecipe.carbon_footprint_ingredients.map(item => ({
        carbon_emission: item.carbon_value,
        converted_unit: null,
        ingredient_cost: null,
        ingredient_id: {
          id: item.id,
          name: item.name,
          unit: "kg",
        },
        ingredient_quantity: item?.CarbonFootprintIngredientMeal?.ingredient_quantity,
        is_local: true
      }));
      setFd({ ...randomRecipe, ingredients: newIngredients });
      return;
    }
  
    if (!fd.name) {
      toast.error(t("PleaseEnterMealName"));
      return;
    }

    if (!fd.servings || fd.servings <= 0) {
      toast.error(t("PleaseEnterServings"));
      return;
    }

    if (!fd.type) {
      toast.error(t("PleaseSelectMealType"));
      return;
    }
  
    setIsAILoading(true);
  
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${storage.getItem('token')}`
      }
    };
    
    try {
      // First Attempt
      let response = await fetchWithTimeout(
        `${process.env.REACT_APP_API_ENDPOINT}/carbon-footprints/meals/get-recommended-recipe/?meal=${fd?.name}&category=${CARBON_MEAL_CATEGORIES.find(i => i.id === fd.category)?.label}`,
        requestOptions
      );
      
      if (!response.ok) throw new Error("Recipe not found");
      
      const randomRecipe = await response.json();
      setRecipe(randomRecipe)
    } catch (error) {
      // Retry Attempt
      try {
        let response = await fetchWithTimeout(
          `${process.env.REACT_APP_API_ENDPOINT}/carbon-footprints/meals/get-recommended-recipe/?meal=${fd?.name}&category=${CARBON_MEAL_CATEGORIES.find(i => i.id === fd.category)?.label}`,
          requestOptions
        );
  
        if (!response.ok) throw new Error("Recipe not found");
  
        const randomRecipe = await response.json();
        setRecipe(randomRecipe)
      } catch (retryError) {
        console.error("Second attempt failed: ", retryError);
        toast.error(t("This recipe is not available. Please try another one."));
      }
    } finally {
      setIsAILoading(false);
    }
  };

  const renderTooltip = (props) => {
    return(
    <Tooltip id="button-tooltip" {...props}>
      {t("PleaseEnterMealNameServingsAndType")}
    </Tooltip>
  )};

  return (
    <>
      <AddIngredientModal
        show={ingredientModal}
        onHide={() => {
          setIngredientModal(false);
          setIsLoadAlternative(true)
          setIsAlternativeLoading(false)
        }}
        data={{ allergens: state.allergens, providers: state.providers }}
        onRowAdded={(ingredientItem, a) => {
          onAddIngredientItem(ingredientItem);
        }}
        isUploadedModal={false}
      />
      {importDocument && <ImportModule title="Extract recipe from a document" setFd={setFd} setFileImportLoading={setFileImportLoading} setIsAILoading={setIsAILoading} modalName='Meal' requestPath='/meals/create-in-bulk' show={importDocument} options={mealsKeys} requiredOptions={requiredMealsKeys} onHide={importModalCloseHandler} providers={state.providers} fdIngredients={ingredients} onRowAdded={onRowAdded} />}
      <Modal
        show={show}
        onHide={() => {
          setIsLoadAlternative(true)
          setIsAlternativeLoading(false)
          setLowerIngredients([])
          setAlternativeIngredients([])
          setNextLoadAlternative(false)
          setIsAILoading(false);
          setSelectedRowIndex(null)
          setSelectedCookingState(null)
          onHide()
        }}                       
        centered
        className="add-meals dashboard-modal"
        dialogClassName="custom-width"
        style={{ padding: "40px" }}
      >
        <Modal.Header closeButton>
          {!isUploaded && (
            <Modal.Title>
              {state.selectedMeal ? t("Edit") : t("Add")} {t("Meal")}(s)
            </Modal.Title>
          )}
        </Modal.Header>

        <Modal.Body>
          <Container className="p-0" style={{ margin: "0px", minWidth: "100%" }}>
            {isUploaded && (
              <div className="d-flex justify-content-center flex-column  text-center upload-container">
                <div>
                  <img src={UploadedIcon} alt="..." />
                </div>
                <div className="heading mt-5">
                  <label>{t("Meal uploaded !")}</label>
                </div>
                <div className="subheading mt-2 mb-5">
                  <label>{t("Your meal has been successfully uploaded.")}</label>
                </div>
                <div>
                  <Button
                    className="add-restaurant-confirm-btn"
                    onClick={onHide}
                  >
                    OK
                  </Button>
                </div>
              </div>
            )}
            {!isUploaded && (
              <>
                <div style={{
                  display:"flex",
                  alignItems:"center",
                  marginBottom: "40px",
                  justifyContent: "space-between",
                }}>
                  {fd?.ingredients?.length > 0 && (
                    <div>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                        marginRight: '10px',
                        flexShrink: '0'
                      }}>
                        {/* <div>
                          <img src={Mic} style={{ background: "#6353EA", cursor: "pointer", borderRadius: "5px", width: "28px", height: "26px", marginRight: "15px", objectFit: "contain" }} onClick={getRandomRecipe} />
                          <span className="add-restaurants-input-title">
                            {t("Recipes generation by voice")}
                          </span>
                        </div> */}
                        <div style={{ position: 'relative' }}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <img src={Calque} style={{ background: "#6353EA", cursor: "pointer", width: "28px", borderRadius: "5px", height: "26px", marginRight: "15px", objectFit: "contain" }} onClick={getRandomRecipe} />
                            <span className="add-restaurants-input-title">
                              {t("Generate a recipe with AI")}
                            </span>
                            <div
                              onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}
                              style={{
                                cursor: "pointer",
                                width: '38px',
                                height: '38px',
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "rgb(243, 244, 251)",
                                borderRadius: "50%",
                                zIndex: '1'
                              }}
                            ><img src={INFO_ICON} style={{ width: "25px" }} /></div>
                          </div>
                          {showInfo && (
                            <div style={{
                              position: 'absolute',
                              left: '205px',
                              bottom: '-4px',
                            }}>
                              <div style={{
                                display: "flex",
                                alignItems: "flex-start",
                                background: "white",
                                borderRadius: "9px",
                                padding: "20px",
                                width: "425px",
                                height: "96px",
                              }}>
                                <img src={Calque_2} style={{ marginRight: "15px" }} />
                                <p style={{ marginBottom: '0px', fontSize: '12px' }}>{t("To save you time, our powered technology by iA will allow you to generatively pre-populate recipes. You can tweak them later!")}
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {fd?.ingredients?.length > 0 && (
                    <div>
                      <Button
                        variant="primary add-btn-container"
                        onClick={() => setImportDocument(true)}
                        style={{ borderRadius: '5px', whiteSpace: 'nowrap' }}
                      >
                        {t("Import from a document")}
                      </Button>
                    </div>
                  )}

                  <div style={{ marginLeft: '20px', width: '40%' }}>
                    <p className="add-restaurants-label-title" >
                      {t("Label of Meal based on carbon emission")}
                    </p>

                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <div className="label-container" style={{ width: '100%', height: '25px', display: 'flex', position: "relative", backgroundColor: '#f2f2f2', borderRadius: '10px' }}>
                        <img style={{ marginRight: "10px", width: "11%", position: "absolute", left: `${offset}%`, top: "-35px", transform: 'translate(-50%, 0%)' }} src={imageUrl} />
                        <span style={{ width: "20%", height: "100%", backgroundColor: offset === 10 ? "transparent" :"#65a700", borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px"}}></span>
                        <span style={{ width: "20%", height: "100%", backgroundColor: offset === 30 ? "transparent" : "#a4f500"}}></span>
                        <span style={{ width: "20%", height: "100%", backgroundColor: offset === 50 ? "transparent" : "#ffc300"}}></span>
                        <span style={{ width: "20%", height: "100%", backgroundColor: offset === 70 ? "transparent" : "#ff1d00"}}></span>
                        <span style={{ width: "20%", height: "100%", backgroundColor: offset === 90 ? "transparent" : "#890500", borderBottomRightRadius: "10px", borderTopRightRadius: "10px"}}></span>
                      </div>
                    </div>
                  </div>
                </div>

                <Form className="ps-0 pe-0" noValidate onSubmit={onSubmit}>
                  {/* Meal name, Type, Servings and Selling filds */}
                  <Row className=" d-flex justify-content-between">
                    <Col lg={12}>
                      <Row>
                        <Col lg={3}>
                        <span className="add-restaurants-input-title ps-0">
                          {t("MealName")} 
                          <span style={{ color: "red", fontSize: "14px" }}> *</span>
                        </span>
                          <CreatableAsyncPaginate
                            key={mealNameSelectKey}
                            value={null}
                            inputValue={fd?.name || ""}
                            onInputChange={(newValue, { action }) => {
                              if (action === "input-change") {
                                setFd(prev => ({ ...prev, name: newValue }));
                              }
                            }}
                            blurInputOnSelect={false}
                            styles={{ borderRadius: "10px" }}
                            loadOptions={loadOptions}
                            onChange={createSelectChange}
                            isDisabled={fileImportLoading || isAILoading}
                            placeholder={t("MealName")}
                            formatCreateLabel={(inputValue) => `${t("Create recipe")} "${inputValue}"`}
                            className="meal-name-select"
                            style={{ whiteSpace: "normal" }}
                          />
                        </Col>
                        <Col lg={2}>
                        <span className="input-title ps-0">
                          {t("MealCode")}
                        </span>
                          <input
                            caption=""
                            name="reference_number"
                            placeholder={t("AddMealCode")}
                            className="form-control input-field"
                            onChange={onTextChange}
                            disabled={fileImportLoading || isAILoading}
                            value={fd?.reference_number}
                            type="text"
                            min="1"
                            step="1"
                          />
                        </Col>
                        <Col lg={2}>
                          <span className="input-title ps-0">{t("MealType")}</span>
                          <SelectInput
                            dataField="category"
                            placeholder={t("SelectMealType")}
                            isDisabled={fileImportLoading || isAILoading}
                            options={CARBON_MEAL_CATEGORIES.map((m) => ({
                              ...m,
                              label: t(m.label),
                            }))}
                            onChange={onSelectionChange}
                            value={
                              CARBON_MEAL_CATEGORIES.find((item) => {
                                if(item.id === fd.category) {
                                  return {...item, label: t(item.label)}
                                }
                              }) ??
                              null
                            }
                          />
                        </Col>
                        <Col lg={1}>
                        <span className="input-title ps-0">
                          {t("Servings")}
                          <span style={{ color: "red", fontSize: "14px" }}> *</span>
                        </span>
                          <input
                            caption=""
                            name="servings"
                            placeholder={t("AddServings")}
                            className="form-control input-field"
                            onChange={onTextChange}
                            disabled={fileImportLoading || isAILoading}
                            value={fd?.servings}
                            type="number"
                            min="1"
                            step="1"
                          />
                        </Col>
                        <Col lg={2}>
                        <span className="input-title ps-0">
                          {t("MealCategory")}
                          <span style={{ color: "red", fontSize: "14px" }}> *</span>
                        </span>
                          <SelectInput
                            dataField="type"
                            placeholder={t("SelectMealType")}
                            isDisabled={fileImportLoading || isAILoading}
                            options={MEAL_CATEGORIES.map((m) => ({
                              ...m,
                              label: t(m.label),
                            }))}
                            onChange={onSelectionChange}
                            value={
                              MEAL_CATEGORIES.find((item) => {
                                if(item.id === fd?.type) {
                                  return {...item, label: t(item.label)}
                                }
                              }) ??
                              null
                            }
                          />
                        </Col>
                        <Col lg={2}>
                        <span className="input-title ps-0">
                          {t("ServiceType")}
                          <span style={{ color: "red", fontSize: "14px" }}> *</span>
                        </span>
                          <SelectInput
                            dataField="service_type"
                            placeholder={t("SelectServiceType")}
                            isDisabled={fileImportLoading || isAILoading}
                            options={SERVICE_TYPES.map((m) => ({
                              ...m,
                              label: t(m.label),
                            }))}
                            onChange={onSelectionChange}
                            value={
                              SERVICE_TYPES.find((item) => {
                                if(item.id === fd?.service_type) {
                                  return {...item, label: t(item.label)}
                                }
                              }) ??
                              null
                            }
                          />
                        </Col>
                        {/* <Col lg={2}>
                          <span className="input-title ps-0">{`${t("SellingPrice")} / ${t("person")} ( $ )`}</span>
                          <input
                            name="selling_price_per_person"
                            caption={`${t("SellingPrice")} / ${t("person")}`}
                            placeholder={t("SellingPrice")}
                            className="form-control input-field"
                            onChange={onTextChange}
                            disabled={fileImportLoading || isAILoading}
                            value={fd?.selling_price_per_person}
                            type="number"
                            min="1"
                            step="1"
                          />
                        </Col> */}
                        {/* <Col lg={3} style={{color:"#000000", display:"flex", alignItems:"flex-end", justifyContent: "space-around"}}>
                        <a className="CE-icon1" style={{height: "100%", position: "relative", cursor: "pointer"}} href={imageUrl} download>
                          <img style={{ width: "70px"}} src={imageUrl}/>
                          <img src={TelechargerIcon} style={{position: "absolute", top: "90%", left: "70%", transform: "translate(-50%, -50%)"}} />
                        </a>
                          <div className="total-cost-container">
                            <div className="total-cost-text">
                              {t("Total CO2eq/servings (kg)")}
                            </div>
                            <div className="total-cost">
                            {(getSum()/(parseInt(fd?.servings) || 1)).toFixed(2)}
                            </div>
                          </div>
                        </Col> */}
                      </Row>
                    </Col>
                  </Row>
                  
                  {/* ingredients and p */}
                  <Row>
                    <Col lg={9}>
                      <Row className="mt-4">
                        <Col lg={12}>
                          <span className="input-title ps-0">
                            {t("Ingredients")}
                          </span>
                          <Card className="mb-0">
                            <div className="p-4 allergens-container">
                              <div className="row custom-table h-100">
                                <div className="col-lg-12 h-100 p-0">
                                  {fd?.ingredients.length > 0 ? (
                                    <>
                                      <div className="tablescroll">
                                        <table className="table" style={{ padding: '0px 20px' }}>
                                          <thead>
                                            <tr>
                                              <td className="text-center">
                                              </td>
                                              <td className="text-center" style={{ width: "30%", fontWeight: "bold" }}>
                                                {t("Ingredients")}
                                              </td>
                                              <td
                                                className="text-center"
                                                style={{ width: "19%", fontWeight: "bold" }}
                                              >
                                                {t("Unit")}
                                              </td>
                                              <td
                                                className="text-center"
                                                style={{ width: "14%", fontWeight: "bold" }}
                                              >
                                                {t("Quantity")}
                                              </td>
                                              <td
                                                className="text-center"
                                                style={{ width: "27%", textAlign: "end", fontWeight: "bold", whiteSpace: "normal" }}
                                              >
                                                {t("Carbon impact (in Kg CO2eq)")}
                                              </td>
                                              <td
                                                className="text-center"
                                                style={{ width: "109%", textAlign: "end", display: "flex", justifyContent: "space-evenly", fontWeight: "bold" }}
                                              >
                                                <span>{t("Local")}</span>
                                                <Col lg={1} style={{ cursor: "pointer" }} onMouseEnter={() => setShowLocalInfo(true)} onMouseLeave={() => setShowLocalInfo(false)} >
                                                  <img src={INFO_ICON} style={{ width: "15px" }} />
                                                  {showLocalInfo && (
                                                    <div style={{
                                                      display: "flex",
                                                      alignItems: "flex-start",
                                                      background: "white",
                                                      borderRadius: "9px",
                                                      padding: "12px",
                                                      position: "absolute",
                                                      top: "60px",
                                                      left: "12x",
                                                      width: "150px",
                                                      zIndex: 19999
                                                    }}>
                                                      <p>{t("localTooltip")}
                                                      </p>
                                                    </div>
                                                  )}
                                                </Col>
                                              </td>
                                              <td
                                                style={{
                                                  width: "37px",
                                                  textAlign: "end",
                                                  fontWeight: "bold"
                                                }}
                                              ></td>
                                            </tr>
                                          </thead>
                                          {
                                            isAILoading ?
                                              <tbody>
                                                <tr>
                                                  <td></td>
                                                  <td></td>
                                                  <td>
                                                    <div style={{ width: "100%", height: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                      <Spinner animation="border" variant="primary" />
                                                    </div>
                                                  </td>
                                                  <td></td>
                                                </tr>
                                              </tbody> :

                                              <tbody>
                                                {(fd.ingredients || []).map(
                                                  (ingredient, i) => {
                                                    return (
                                                      <React.Fragment key={i}>
                                                        <tr onDoubleClick={() => handleRowClick(i)} style={{ cursor: "pointer", borderRadius: '37px', boxShadow: `0px 1px 6px 0px ${ingredient.seasonal_months?.some((month => month?.toLowerCase() === currentMonth.toLowerCase())) ? "#00000040" : "red"}`, zIndex: selectedRowIndex === i ? 2 : 0, position: "relative" }} key={i}>
                                                          <td style={{
                                                             height: "50px",
                                                             borderTopLeftRadius: "37px",
                                                             borderBottomLeftRadius: "37px",
                                                             padding: "0px 0px 0px 12px",
                                                          }}>
                                                            {ingredient?.image_path ? (
                                                              <img src={`https://fullsoon-uploads-dev.s3.eu-west-1.amazonaws.com/co2/ingredients/images/${encodeURIComponent(ingredient?.image_path.split('images/')[1])}`} style={{ borderRadius: "50%", width: "50px", height: "50px", objectFit: "contain" }} alt="" />
                                                            ) : (
                                                              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "50px", height: "50px" }}>
                                                                <img src={NO_IMAGE_ICON} style={{ borderRadius: "50%", width: "30px", height: "30px", objectFit: "contain" }} alt="" />
                                                                <span style={{ fontSize: "7px", color: "#B5B7C0", whiteSpace: "nowrap" }}>{t("No image")}</span>
                                                              </div>
                                                            )}
                                                          </td>
                                                          <td>
                                                          <SelectAsyncPaginate
                                                            {...(is_demo && { datasource: dummyDatasource })}
                                                            dataField="ingredient_id"
                                                            placeholder={t("SelectIngredient")}
                                                            value={ingredient}
                                                            isMulti={false}
                                                            query="carbon-footprints/ingredients"
                                                            onChange={onIngredientSelectBoxChange(i)}
                                                            cacheOptions  // caching enabled
                                                            mapper={(rows) =>
                                                              rows
                                                                .filter((row, index, self) =>
                                                                  index === self.findIndex((t) => t.name === row.name)
                                                                )
                                                                .map((row) => {
                                                                  return {
                                                                  ...row,
                                                                  name: row?.source === 'get-co2-emission'
                                                                  ? t("Get an estimation for ") + t(row.name)
                                                                  : t(row.name)
                                                                }})
                                                            }
                                                          />
                                                          </td>
                                                          <td className="">
                                                            <SelectInput
                                                              portal={true}
                                                              dataField="ingredient_unit"
                                                              placeholder={t("SelectUnit")}
                                                              options={translatedCO2Units}
                                                              onChange={onIngredientSelectBoxChange(
                                                                i
                                                              )}
                                                              value={translatedCO2Units.find(({ id }) => id === (ingredient.converted_unit || ingredient.ingredient_unit))}
                                                            />
                                                          </td>
                                                          <td className="">
                                                            <input
                                                              placeholder="format"
                                                              name="ingredient_quantity"
                                                              onChange={onIngredientTextBoxChange(
                                                                i
                                                              )}
                                                              className="form-control custom-input"
                                                              value={
                                                                ((ingredient?.converted_quantity) ||
                                                                ingredient?.ingredient_quantity) || ""
                                                               }
                                                              type="text"
                                                            />
                                                          </td>
                                                          <td className="text-center"
                                                            style={{
                                                              fontSize: "12px",
                                                              userSelect: "none",
                                                              color: getColorBasedOnCarbonEmission(ingredient.carbon_emission).color
                                                            }}>
                                                              {/* If country is other than France then increase CO2 value by 10% */}
                                                            {ingredient.carbon_emission ? `${ingredient.country === 'France' ? (ingredient.carbon_emission * 0.90).toFixed(3) : ingredient.carbon_emission.toFixed(3)} kg` : null}
                                                          </td>

                                                          {/* <td className="text-center">
                                                          {(ingredient?.ingredient_cost) || null}
                                                        </td> */}

                                                          <td className="text-center"
                                                          >
                                                            {/* {(ingredient?.ingredient_cost) || null} */}
                                                            <Form.Check aria-label="option 1" onChange={() => onLocalCheckboxChange(i)} checked={ingredient?.is_local} />
                                                          </td>

                                                          <td style={{
                                                            borderTopRightRadius: "37px",
                                                            borderBottomRightRadius: "37px",
                                                          }}>
                                                            <button
                                                              type="button"
                                                              onClick={deleteIngredient(i)}
                                                              className="table-delete-btn p-0"
                                                            >
                                                              <img src={CLOSE_ICON} alt="" />
                                                            </button>
                                                          </td>
                                                        </tr>

                                                        {selectedRowIndex === i && (
                                                          <tr style={{
                                                            position: 'relative',
                                                            top: '-40px',
                                                            zIndex: '1',
                                                            boxShadow: 'none'
                                                          }}>
                                                            <td colSpan="7" style={{ padding: "0" }}>
                                                              <table className="table" style={{width: "90%", margin:'auto'}}>
                                                                <tbody>
                                                                  <tr style={{
                                                                    boxShadow: 'rgba(0, 0, 0, 0.25) 0px 1px 6px 0px',
                                                                    borderBottomRightRadius: '25px',
                                                                    borderBottomLeftRadius: '25px',
                                                                  }}>
                                                                    <td style={{
                                                                      borderBottomLeftRadius: '25px',
                                                                      width: "220px"
                                                                    }}>
                                                                      <p style={{ color: "#B5B7C0", fontSize: "14px", fontWeight: "600" }}>{t("Characteristics")}</p>
                                                                      <select
                                                                        value={selectedCookingState || 'No cooking methodology'}
                                                                        style={{ border: "1px solid #E0E0E0", height: "38px", borderRadius: "5px", width: "165px" }}
                                                                        onChange={(e) => handleCookingMethodologyChange(e, ingredient)} 
                                                                        // onClick={(e) => handleCookingMethodologyChange2(e, ingredient)}
                                                                        >
                                                                        {cookingStates.map((state) => {
                                                                          // let cookingState = COOKING_OPTIONS.find((option) => option.value === state)
                                                                         return <option key={state} value={state}>
                                                                            {t(state)}
                                                                          </option>
                                                                        }
                                                                        )}
                                                                      </select>

                                                                    </td>
                                                                    <td style={{  
                                                                      textAlign: "center",
                                                                      fontFamily: "Nunito Sans",
                                                                      color: "black"
                                                                      }}>
                                                                      <p style={{ color: "#B5B7C0", fontSize: "14px", fontWeight: "600" }}>{t("Season")}</p>
                                                                      <p>
                                                                        {(() => {
                                                                          const currentMonth = new Date().toLocaleString('en-US', { month: 'long' });
                                                                          const seasonalMonths = ingredient.seasonal_months || [];
                                                                          return seasonalMonths.some((month => month?.toLowerCase() === currentMonth.toLowerCase()))
                                                                            ? <span>{t("In season")}</span>
                                                                            : <span style={{ color: "red" }}>{t("No season")}</span>
                                                                        })()}
                                                                      </p>                                                            
                                                                    </td>
                                                                    <td className="country-of-origin" style={{ height: "auto" }}>
                                                                        <p style={{ color: "#B5B7C0", fontSize: "14px", fontWeight: "600", textAlign: "center" }}>{t("Country of origin")}</p>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            value={translatedCountryOptions.find(c => c.value === ((selectedRestaurant?.country) || ingredient.country))}
                                                                            components={{ Option: CountryOption, SingleValue: CountrySingleValue }}
                                                                            options={translatedCountryOptions}
                                                                            onChange={(event) => {
                                                                              handleChange(event, i);
                                                                            }}
                                                                            isSearchable={true}
                                                                            placeholder={t("Choose a country")}
                                                                          />
                                                                    </td>
                                                                    <td style={{
                                                                      borderBottomRightRadius: '25px',
                                                                      textAlign: "center",
                                                                      fontFamily: "Nunito Sans",
                                                                      color: "black"
                                                                    }}>
                                                                      <p style={{ color: "#B5B7C0", fontSize: "14px", fontWeight: "600" }}>{t("Nutritive value")}</p>
                                                                      <p>{ingredient?.nutritive_value || '0'}&nbsp;Kcal</p>
                                                                    </td>
                                                                  </tr>
                                                                </tbody>
                                                              </table>
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </React.Fragment>
                                                    )
                                                  }
                                                )}
                                              </tbody>
                                          }
                                        </table>
                                      </div>
                                    </>
                                  ) : isAILoading ? (
                                    <div style={{ width: "100%", height: "200px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                      <Spinner animation="border" variant="primary" />
                                    </div>
                                  ) :
                                    <div className="button-container" style={{ marginBottom: "35px", display: "flex", justifyContent: "space-around" }}>
                                      {/* <Button
                                        variant="primary add-btn-container"
                                        style={{ display: "flex", borderRadius: "5px", marginRight: "65px", height: "38px", minWidth: "max-content" }}
                                      >
                                        <img src={Mic} style={{ background: "#6353EA", cursor: "pointer", borderRadius: "5px", marginRight: "15px" }} />
                                        {t("Generate by voice")}
                                      </Button> */}
                                       <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={(!fd?.name || !fd?.servings || !fd?.type) ? renderTooltip : <></>} 
                                      >
                                        <span style={{ display: "inline-block"}}>
                                          <Button
                                            variant="primary add-btn-container"
                                            onClick={getRandomRecipe}
                                            disabled={!fd?.name || !fd?.servings || !fd?.type} 
                                            style={{
                                              display: "flex",
                                              borderRadius: "5px",
                                              marginRight: "65px",
                                              height: "38px",
                                              pointerEvents: (!fd?.name || !fd?.servings || !fd?.type) ? 'none' : 'auto',
                                            }}
                                          >
                                            <img
                                              src={Calque}
                                              style={{
                                                width: "30px",
                                                borderRadius: "5px",
                                                objectFit: "contain",
                                                height: "28px",
                                                marginRight: "15px",
                                              }}
                                              onClick={getRandomRecipe}
                                              alt="Generate by IA"
                                            />
                                            {t("Generate by IA")}
                                          </Button>
                                          </span>
                                      </OverlayTrigger>
                                      <Button
                                        variant="primary add-btn-container"
                                        onClick={() => setImportDocument(true)}
                                        style={{ borderRadius: "5px", marginRight: "65px", height: "38px", minWidth: "121px", textAlign: "center" }}
                                      >
                                        <img
                                              src={ImportIcon}
                                              style={{
                                                background: "#6353EA",
                                                width: "15px",
                                                borderRadius: "5px",
                                                objectFit: "contain",
                                                height: "19px",
                                                marginRight: "15px",
                                                marginLeft: "15px"
                                              }}
                                              alt="Import document"
                                            />
                                        {t("Import")}
                                      </Button>
                                      {/* <Button
                                        variant="primary add-btn-container"
                                        // onClick={() => setImportDocument(true)}
                                        style={{textAlign: "center", borderRadius: "5px", height: "38px", width: "max-content", minWidth: "max-content" }}
                                        disabled={true}
                                      >
                                        <img
                                              src={ExistingRecipeIcon}
                                              style={{
                                                background: "#6353EA",
                                                width: "15px",
                                                borderRadius: "5px",
                                                objectFit: "contain",
                                                height: "19px",
                                                marginRight: "15px",
                                              }}
                                              alt="Import document"
                                            />
                                        {t("Reuse Existing recipe")}
                                      </Button> */}
                                    </div>
                                  }
                                  {}
                                  <div className="bottom-container d-flex justify-content-between">
                                    <Button
                                      variant="add-ingredient"
                                      onClick={onAddIngredientItem}
                                      style={{ width: "100%", boxShadow: "0px 1px 6px 0px #00000040", borderRadius: "100px" }}
                                    >
                                      <img
                                        src={Addicon}
                                        className="add-btn-icon"
                                        alt="..."
                                      />
                                    </Button>
                                  </div>
                                  <div className="total-cost-container">
                                    <div className="total-cost-text">
                                      {t("Total CO2eq (Kg)")}
                                    </div>
                                    <div className="total-cost">
                                      {getSum().toFixed(2)}
                                    </div>
                                    {/* {Boolean(fd.servings && getSum()) && (
                                      <div className="pre-serving">
                                        {(getSum() / fd.servings).toFixed(2)} EUR
                                        / {t("servings")}
                                      </div>
                                    )} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={3} style={{ marginTop: "40px", position: "relative" }} className="coeq-container">
                      <Card className="coeq-card left" style={{ minHeight: "100%"}}>
                      <a style={{ cursor: "pointer", textDecoration: "none", height: "97px"}} href={imageUrl} download>
                        <Card style={{height: "113px", padding: "6px"}} className="download-icon-container">
                        <img src={TelechargerIcon} style={{position: "absolute", top: "20%", left: "80%", transform: "translate(-50%, -50%)"}} />
                          <div style={{ width: "100%", height: "50px" }}>
                            <img style={{ width: "100%", height: "90%", objectFit: "contain" }} src={imageUrl} />
                          </div>
                          <div style={{ width: "100%", textAlign: "center" }}>
                            <h5 style={{ fontWeight: "600", color: currentColor, margin: "1px" }}>{fd?.name}</h5>
                          </div>
                          <Card style={{ width: "max-content", boxShadow: "0px 3px 16px -8px rgba(0,0,0,0.52)"}}>
                            <p className="weight-container" style={{ margin: "0px", borderColor: currentColor, lineHeight: "19px", color: currentColor }}>{((getSum()/(fd.servings || 1)) || 0).toFixed(2)} Kg</p>
                          </Card>
                        </Card>
                      </a>
                        <div className="card-body">
                          {fd?.ingredients?.map((item, index) => (<ProgressItem key={index} style={{ marginTop: index === 0 ? "0px" : "24px" }} name={translateIngredientName(item?.ingredient_id?.name, currentLanguage) || " "} value={((item?.carbon_emission / sumOfCarbonValue) * 100)?.toFixed(1)} />))}
                        </div>
                      </Card>
                    </Col>
                  </Row>

                  {/* alternative CO2 ingredients */}
                <Row className="mt-4">
                  <Col lg={12}>
                    <span className="input-title ps-0">
                      {t("Ingredients")}/{t("Meals")}
                    </span>
                    <Card className="mb-0">
                      <div className="p-4 allergens-container">
                        <div className="row custom-table h-100">
                          <div className="col-lg-12 h-100 p-0">
                            <div>
                              <h3 style={{
                                color: "#000000",
                                fontSize: "21px",
                                fontWeight: "700",
                                paddingBottom: "17px"
                              }}>{t("Alternative ingredients with lower CO2eq")}</h3>
                            </div>
                            <div className="tablescroll">
                              <table className="table" style={{ padding : "0px 20px"}}>
                                <thead>
                                  <tr>
                                    <td className="text-center" style={{ width: "35%", fontWeight: "bold" }}>
                                      {t("Instead of")}
                                    </td>
                                    <td className="text-center" style={{ width: "10%", fontWeight: "bold" }}>
                                      {t("Switch to")}
                                    </td>
                                    <td className="text-center" style={{ width: "35%", fontWeight: "bold" }}>
                                      {t("Alternative ingredient")}
                                    </td>
                                    <td
                                      className="text-center"
                                      style={{ width: "10%", fontWeight: "bold" }}
                                    >
                                      {t("Unit")}
                                    </td>
                                    <td
                                      className="text-center"
                                      style={{ width: "15%", fontWeight: "bold" }}
                                    >
                                      {t("Quantity")}
                                    </td>
                                    <td
                                      className="text-center"
                                      style={{ width: "20%", textAlign: "end", fontWeight: "bold" }}
                                    >
                                      {t("Carbon - Emission")}
                                    </td>
                                    <td
                                      style={{
                                        width: "37px",
                                        textAlign: "end",
                                        fontWeight: "bold"
                                      }}
                                    ></td>
                                  </tr>
                                </thead>
                                {isAlternativeLoading ?
                                <tbody>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td>
                                      <div style={{ width: "100%", height: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Spinner animation="border" variant="primary" />
                                      </div>
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                                : isLoadAlternative ? <tbody>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td>
                                      <div style={{ width: "100%", height: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Button disabled={fd?.ingredients?.length == 0 || fd?.ingredients?.some((element) => element?.name?.length === 0)} style={{ whiteSpace: "normal" }} onClick={getLowerIngredients}>{t("Load low carbon ingredients")}</Button>
                                      </div>
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                                  :
                                      <tbody>
                                        {(lowerIngredients || []).map(
                                          (ingredient, i) => {
                                            const matchingElementOriginal = translateIngredientName(ingredient.original_ingredient,currentLanguage);
                                            const matchingElementAlternative = translateIngredientName(ingredient.alternative_ingredient,currentLanguage);
                                            return (
                                              <tr key={i} style={{
                                                borderRadius: '37px', 
                                                boxShadow: "0px 1px 6px 0px #00000040"
                                              }}>
                                                <td style={{
                                                  height: "50px",
                                                  borderTopLeftRadius: "37px",
                                                  borderBottomLeftRadius: "37px"
                                                }}>
                                                  <SelectInput
                                                    portal={true}
                                                    dataField="ingredient_id"
                                                    placeholder={t("SelectIngredient")}
                                                    options={getConvertibleUnitOptions(ingredient?.converted_unit || ingredient?.ingredient_unit)}
                                                    onChange={onIngredientSelectBoxChange(
                                                      i
                                                    )}
                                                    value={{ label: matchingElementOriginal?.length ? matchingElementOriginal : ingredient.original_ingredient, value: "kg", id: "kg" }}
                                                  />
                                                </td>
                                                <td style={{ height: "50px", textAlign: "center" }}>
                                                  <img style={{ cursor: "pointer" }} onClick={() => updateRecipe(i)} src={SWITCH} alt="switch" />
                                                </td>
                                                <td style={{ height: "auto", whiteSpace: "normal" }}>
                                                  <SelectInput
                                                    portal={true}
                                                    dataField="ingredient_id"
                                                    placeholder={t("SelectIngredient")}
                                                    options={getConvertibleUnitOptions(ingredient?.converted_unit || ingredient?.ingredient_unit)}
                                                    onChange={onIngredientSelectBoxChange(
                                                      i
                                                    )}
                                                    value={{ label: matchingElementAlternative?.length ? matchingElementAlternative : ingredient.alternative_ingredient, value: "kg", id: "kg" }}
                                                  />
                                                </td>
                                                <td style={{ height: "auto", whiteSpace: "normal" }}>
                                                  <SelectInput
                                                    portal={true}
                                                    dataField="alternative_ingredient_unit"
                                                    placeholder={t("SelectUnit")}
                                                    isDisabled={false}
                                                    options={getConvertibleUnitOptions(ingredient?.unit || ingredient?.unit)}
                                                    onChange={onIngredientSelectBoxChange(
                                                      i
                                                    )}
                                                    value={{ label: ingredient.unit, value: ingredient.unit, id: ingredient.unit }}
                                                  />
                                                </td>
                                                <td className="">
                                                  <input
                                                    placeholder="format"
                                                    name="alternative_ingredient_quantity"
                                                    onChange={onIngredientTextBoxChange(
                                                      i
                                                    )}
                                                    value={ingredient?.ingredient_quantity}
                                                    type="number"
                                                    className="form-control custom-input"
                                                  />
                                                </td>
                                                <td className="text-center"
                                                  style={{
                                                    fontSize: "12px",
                                                    color: getColorBasedOnCarbonEmission(ingredient?.alternative_co2_impact_per_kg).color
                                                  }}>
                                                  {ingredient?.alternative_co2_impact_per_kg ? ingredient.alternative_country === 'France' ? `${(ingredient.alternative_co2_impact_per_kg * 0.90)?.toFixed(3)} CO2-eq` : `${(ingredient.alternative_co2_impact_per_kg)?.toFixed(3)} CO2-eq` : null}
                                                </td>
                                                <td style={{
                                                  borderTopRightRadius: "37px",
                                                  borderBottomRightRadius: "37px",
                                                  padding: "10px !important"
                                                }}>
                                                  <button
                                                    type="button"
                                                    onClick={deleteLowerIngredient(i)}
                                                    className="table-delete-btn p-0"
                                                  >
                                                    <img src={CLOSE_ICON} alt="" />
                                                  </button>
                                                </td>
                                              </tr>
                                            )
                                          }
                                        )}
                                        {!allAlternativesExhausted && (
                                        <tr className="bg-transparent">
                                          <td className="bg-transparent"></td>
                                          <td></td>
                                          <td>
                                            <div style={{ width: "100%", height: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                              <Button disabled={fd?.ingredients?.length == 0 || fd?.ingredients?.some((element) => element?.name?.length === 0)} style={{ whiteSpace: "normal" }} onClick={getLowerIngredients}>{t("Reload Alternatives")}</Button>
                                            </div>
                                          </td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                        </tr>
                                        )}
                                      </tbody>}
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Card>
                    </Col>
                  </Row>

                  {/* allergen and download file */}
                  <Row className="mt-4">
                    <Col lg={8}>
                      <Row>
                        <Col lg={12}>
                          <span className="input-title ps-0">{t("Allergens")}</span>
                          <Card className="mb-0">
                            <div className="p-4 allergens-container">
                              {state.allergens.map((allergen, key) => (
                                <Badge
                                  key={key}
                                  pill
                                  className={`allergens-badge ${
                                    fd.allergens.includes(allergen.id) ? "active" : ""
                                  }`}
                                  onClick={onAllergenClick(allergen)}
                                >
                                  {t(allergen.name)}
                                </Badge>
                              ))}
                            </div>
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={4}>
                      <Row className="mt-4 photo-container">
                        <Col lg={12}>
                          <div className="">
                            <div {...getRootProps({ className: "dropzone" })}>
                              <input {...getInputProps()} />
                              <p>{t("Drag&Drop")}</p>
                            </div>
                            <aside>
                              <div className="files-list">
                                <ul>
                                  {files.map((file, i) => (
                                    <li
                                      key={i}
                                      className="d-flex justify-content-between"
                                    >
                                      <div className="d-flex">
                                        <img src={JPEG_ICON} alt="..." />
                                        <p className="ps-3">
                                          <span>{file.path}</span>
                                          <span className="size">
                                            {parseInt(file.size * 0.001)} Kb
                                          </span>
                                        </p>
                                      </div>
                                      <div>
                                        <img
                                          src={EYE_ICON}
                                          alt="..."
                                          className="eye me-3"
                                        />
                                        <img
                                          src={CLOSE_ICON}
                                          alt="..."
                                          className="close"
                                          onClick={onRemoveFile(file, i)}
                                        />
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </aside>
                            <aside style={thumbsContainer}>{thumbs}</aside>
                            {fd.image_path && !files.length && (
                              <div style={thumb}>
                                <div style={thumbInner}>
                                  <img src={fd.image_path} style={img} alt="..." />
                                </div>
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                


                  {/* Conferm Button */}
                  <Row>
                    <Col lg={8}>
                      <Modal.Footer className="add-restaurants-modal-footer" style={{
                        display: "flex",
                        justifyContent: "center"
                      }}>
                        <Button
                          type="submit"
                          className="add-restaurant-confirm-btn"
                          disabled={isSubmitDisabled}
                          style={{ width: "100%", borderRadius: "5px", height: "40px" }}
                        >
                          {t("Confirm")}
                        </Button>
                      </Modal.Footer>
                    </Col>
                  </Row>
                </Form>
              </>
            )}
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CustomModal
